import React from "react";

const RotatingCoin = () => (
  <div id="coin">
    <div className="coin-back" />
    {[...Array(9)].map((_, i) => (
      <div key={i} className="coin-middle" />
    ))}
    <div className="coin-front" />
  </div>
);

export default RotatingCoin;